module.exports = __webpack_public_path__ + "static/img/qlbank.09f1f45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/qlbank.png
// module id = C/7f
// module chunks = 93